// recursive loop through object and replace undefined with null
export const replaceUndefinedWithNull = (obj: any) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] === undefined) {
        obj[key] = null
      } else if (typeof obj[key] === 'object') {
        replaceUndefinedWithNull(obj[key])
      }
    }
  }
  return obj || null
}

export const cleanUpNullUndefined = <T extends object>(obj: T): T => {
  if (!obj || !(typeof obj === 'object') || Array.isArray(obj)) return obj
  return Object.keys(obj).reduce((acc, key) => {
    const typedKey = key as keyof T
    if (obj[typedKey] !== null && obj[typedKey] !== undefined) {
      acc[typedKey] = obj[typedKey]
    }
    return acc
  }, {} as T)
}

export const wrapFormatFn = <T extends (...args: any[]) => any>(
  formatFn: T,
) => {
  return (...params: Parameters<T>): ReturnType<T> => {
    try {
      const result = formatFn(...params)
      return cleanUpNullUndefined(result) as ReturnType<T>
    } catch {}
    return {} as ReturnType<T>
  }
}
